// extracted by mini-css-extract-plugin
export default {"security":"security_security__l-cHh","form":"security_form__8fSYM","security__input":"security_security__input__hxdxb","ar":"security_ar__L0zzo","image":"security_image__orZti"};